import React, { useEffect, useState } from 'react';
import { getAuthToken } from '../../auth/context/AuthContext';

const API = `${process.env.REACT_APP_API_URL || 'https://recruitai.pingitright.com/api'}/platform`;

export default function WalletReport() {
  const [report, setReport] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    let gone = false;
    (async () => {
      try {
        const res = await fetch(`${API}/wallet-report`, {
          headers: { Authorization: `Bearer ${getAuthToken()}` },
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.detail || 'Could not load the report');
        if (!gone) setReport(data);
      } catch (e) {
        if (!gone) setErr(e.message);
      }
    })();
    return () => { gone = true; };
  }, []);

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <div className="page-title">Wallet profit</div>
          <div className="page-subtitle">
            AI charged is in the company currency. Cost and profit in dollars are the measured API cost.
          </div>
        </div>
      </div>
      {err && <div className="alert alert-error">{err}</div>}
      {!report && !err && <div className="empty-state-text">Loading…</div>}
      {report && (
        <>
          <div className="card" style={{ marginBottom: 16, padding: 16 }}>
            <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>Profit in dollars</div>
            <div style={{ fontSize: 28, fontWeight: 700 }}>{report.profit_usd_display}</div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 6 }}>{report.rate_note}</div>
          </div>
          <div className="card" style={{ overflowX: 'auto' }}>
            <table className="table" style={{ width: '100%', fontSize: 13 }}>
              <thead>
                <tr>
                  <th>Company</th>
                  <th>Balance</th>
                  <th>Added</th>
                  <th>Starter</th>
                  <th>AI charged</th>
                  <th>Cost in $</th>
                  <th>Profit</th>
                  <th>Profit in $</th>
                </tr>
              </thead>
              <tbody>
                {(report.companies || []).map(row => (
                  <tr key={row.company_id}>
                    <td style={{ fontWeight: 600 }}>{row.name}</td>
                    <td>{row.balance_display}</td>
                    <td>{row.added_display}</td>
                    <td>{row.starter_display}</td>
                    <td>{row.charged_display}</td>
                    <td>{row.estimated_cost_display}</td>
                    <td>{row.profit_display}</td>
                    <td>{row.profit_usd_display}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
